import { render, staticRenderFns } from "./FactoryForm.vue?vue&type=template&id=4fadee70&scoped=true&"
import script from "./FactoryForm.vue?vue&type=script&lang=js&"
export * from "./FactoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fadee70",
  null
  
)

export default component.exports